import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { PollCaosConfigurationUpdateStatusResData } from "./PollCaosConfigurationUpdateStatusResData";

const ENDPOINT = "/caosconfiguration/update/status";

export class PollCaosConfigurationUpdateStatusCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: PollCaosConfigurationUpdateStatusReqData;

    constructor(payload: PollCaosConfigurationUpdateStatusReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<PollCaosConfigurationUpdateStatusResData> {
        let res = await this.executeCommand(this.payload);
        return new PollCaosConfigurationUpdateStatusResData(res);
    }
}

export class PollCaosConfigurationUpdateStatusReqData {
    installationNames: Array<string>;
    constructor(other: string[]) {
        this.installationNames = other;
    }
}
